import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './Menu.css';

const Menu = () => {
  return (
    <div className="menu-page">
      <Navigation />
      <div className="menu-content">
        <div className="menu-header">
          <Link to="/">
            <img src={require('../assets/FH_Logo-on-LG-Green.png')} alt="Forage Hill Cafe" className="catering-logo" />
          </Link>
          <h2>All Day Menu</h2>
        </div>
        <div className="menu-sections">
          {/* Column 1 - Drinks */}
          <div>
            <div className="menu-section">
              <h2>Drinks</h2>
              <div className="menu-items">
                <div className="menu-item">
                  <span className="menu-item-name">Coffee</span>
                  <span className="menu-item-price">Small $5.8 | Large $6.8</span>
                </div>
                <div className="menu-item-options">
                  <div className="menu-item-option">Long Black</div>
                  <div className="menu-item-option">Flat White</div>
                  <div className="menu-item-option">Latte</div>
                  <div className="menu-item-option">Cappuccino</div>
                  <div className="menu-item-option">Mocha</div>
                  <div className="menu-item-option">Hot Chocolate</div>
                  <div className="menu-item-option">Chai Latte</div>
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Short Black</span>
                  <span className="menu-item-price">$4.5</span>
                </div>

                <div className="menu-item-options small-text">
                  <div className="menu-item-option">Almond, Coconut, Oat, Soy Milk $1.00</div>
                  <div className="menu-item-option">Decaf, Caramel, Vanilla, Hazelnut Shot $1.00</div>
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Teas</span>
                  <span className="menu-item-price">$5.5</span>
                </div>
                <div className="menu-item-options">
                  <div className="menu-item-option">Early Grey, English Breakfast,</div>
                  <div className="menu-item-option">Chamomile, Peppermint, Green,</div>
                  <div className="menu-item-option">Ginger & Lemon</div>
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Iced Drinks</span>
                </div>
                <div className="menu-item-grid">
                  <div className="menu-item-column">
                    <div className="menu-item-price">$8</div>
                    <div className="menu-item-option">Iced Americano</div>
                    <div className="menu-item-option">Peach Iced Tea</div>
                    <div className="menu-item-option">Lemon Iced Tea</div>
                  </div>
                  <div className="menu-item-column">
                    <div className="menu-item-price">$9</div>
                    <div className="menu-item-option">Blended Iced Chocolate</div>
                    <div className="menu-item-option">Blended Iced Coffee</div>
                    <div className="menu-item-option">Blended Iced Mocha</div>
                    <div className="menu-item-option">Iced Latte</div>
                  </div>
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Smoothies</span>
                  <span className="menu-item-price">$9</span>
                </div>
                <div className="menu-item-options">
                  <div className="menu-item-option">Tropical Fruit</div>
                  <div className="menu-item-option">Mixed Berries</div>
                  <div className="menu-item-option">Apple & Feijoa</div>
                  <div className="menu-item-option">Mango</div>
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Milkshakes</span>
                  <span className="menu-item-price">$10</span>
                </div>
                <div className="menu-item-options">
                  <div className="menu-item-option">Chocolate - Banana - Strawberry - Salted Caramel - Cookies</div>
                  <div className="menu-item-option">& Cream</div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2 - All Day Breakfast */}
          <div>
            <div className="menu-section">
              <h2>All Day Breakfast</h2>
              <div className="menu-items">
                <div className="menu-item">
                  <span className="menu-item-name">Forage Hill Brekkie</span>
                  <span className="menu-item-price">$26 (gf*)</span>
                </div>
                <div className="menu-item-description">
                  Free range eggs, tomato, bacon, chorizo, herbed potato rosti, sautéed mushrooms,
                  served with ciabatta
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Omelette with Ciabatta</span>
                  <span className="menu-item-price">$22 (gf*)</span>
                </div>
                <div className="menu-item-options">
                  <div className="menu-item-option">Ham, cheese, tomato</div>
                  <div className="menu-item-option">OR</div>
                  <div className="menu-item-option">Mushroom, feta, pesto, baby spinach</div>
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Bene on Ciabatta</span>
                  <span className="menu-item-price">$21 (gf*)</span>
                </div>
                <div className="menu-item-description">
                  Free range eggs, spinach, hollandaise with choice of bacon / smoked salmon / mushroom
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Creamy Mushrooms</span>
                  <span className="menu-item-price">$19 (gf*)</span>
                </div>
                <div className="menu-item-description">
                  Mushrooms, basil, garlic, onion, parmesan served with ciabatta
                </div>
                <div className="menu-item-options">
                  <div className="menu-item-option">+bacon $5</div>
                  <div className="menu-item-option">+egg $4</div>
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Free Range Eggs Your Way on Ciabatta</span>
                  <span className="menu-item-price">$12.50 (gf*)</span>
                </div>
                <div className="menu-item-description">
                  Poached / fried / scrambled
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Sides</span>
                </div>
                <div className="menu-item-grid">
                  <div className="menu-item-column">
                    <div className="menu-item-option">Egg $4</div>
                    <div className="menu-item-option">Bacon $5</div>
                    <div className="menu-item-option">Chorizo $5</div>
                    <div className="menu-item-option">Herbed Potato Rosti $5</div>
                    <div className="menu-item-option">Grilled Halloumi $5</div>
                  </div>
                  <div className="menu-item-column">
                    <div className="menu-item-option">Avocado $6</div>
                    <div className="menu-item-option">Sautéed Mushroom $5</div>
                    <div className="menu-item-option">Smoked Salmon $7</div>
                    <div className="menu-item-option">Grilled tomatoes $5</div>
                    <div className="menu-item-option">Chips $6</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 3 - All Day Lunch */}
          <div>
            <div className="menu-section">
              <h2>All Day Lunch</h2>
              <div className="menu-items">
                <div className="menu-item">
                  <span className="menu-item-name">Chicken Burger</span>
                  <span className="menu-item-price">$24</span>
                </div>
                <div className="menu-item-description">
                  Chicken, brioche bun, lettuce, tomato, cheese, aioli, served with chips
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Chicken Bacon Burger</span>
                  <span className="menu-item-price">$26</span>
                </div>
                <div className="menu-item-description">
                  Crispy chicken, brioche bun bacon, BBQ sauce, lettuce, tomato, cheese, aioli, served with chips
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Cheese Burger</span>
                  <span className="menu-item-price">$24</span>
                </div>
                <div className="menu-item-description">
                  Beef patty, brioche bun, grilled onion, lettuce, tomato, cheese, aioli, tomato sauce, served with chips
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Kiwi Classic Burger</span>
                  <span className="menu-item-price">$26</span>
                </div>
                <div className="menu-item-description">
                  Beef patty, brioche bun, egg, beetroot, lettuce, tomato, onion, cheese, mustard, aioli, tomato sauce, served with chips
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Potato Rosti Burger</span>
                  <span className="menu-item-price">$25 (v)</span>
                </div>
                <div className="menu-item-description">
                  Potato Rosti, brioche bun, lettuce, tomato, grilled halloumi, chilli mayo, served with chips
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Battered Fish & Chips</span>
                  <span className="menu-item-price">$22</span>
                </div>
                <div className="menu-item-description">
                  Battered fish fillets, mixed cabbage slaw, tartare sauce, lemon, chips
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">Bowl of Wedges</span>
                  <span className="menu-item-price">$19</span>
                </div>
                <div className="menu-item-description">
                  Wedges, crispy bacon, cheese, sour cream, sweet chilli sauce
                </div>

                <div className="menu-item">
                  <span className="menu-item-name">BLAT</span>
                  <span className="menu-item-price">$26 (gf*)</span>
                </div>
                <div className="menu-item-description">
                  Bacon, lettuce, tomato, avocado, BBQ sauce, aioli, served with chips
                </div>

                <div className="menu-note">
                  gf = gluten free
                  <br />
                  gf* = gluten free option
                  <br />
                  v = vegetarian
                  <br />
                  Please let staff know if you have any dietary requirements
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
